import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as cls from 'classnames';
import { Route, Link, withRouter } from 'react-router-dom';
import { Summary } from './Summary';

@withRouter
export class ActiveMemberList extends React.Component<any, any> {
    constructor(props) {
        super(props);
    }

    render() {

        const { location, children, members, theme, ...props } = this.props;

        let onlineUsers = undefined;
        let offlineUsers;

        if (members) {
            onlineUsers = members.filter(m => m.online).map((item, index) => { return <Summary key={"m-online-" + item.id} name={item.name} online={item.online} theme={theme} /> });
            offlineUsers = members.filter(m => !m.online).map((item, index) => { return <Summary key={"m-offline-" + item.id} name={item.name} online={item.online} theme={theme} /> });
        }


        return (<div className="fixed-scrolling">
            <div className="scrolling-y">
                <strong>ONLINE NOW</strong>
                {onlineUsers}
                <br />
                <strong className="mt-2">OFFLINE</strong>
                {offlineUsers}
            </div>
        </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/DiscussionBoard/Member/ActiveList.tsx